/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Reliability_TitleInputs */

const fr_legal_reliability_title = /** @type {(inputs: Legal_Reliability_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsabilité & Fiabilité`)
};

const en_legal_reliability_title = /** @type {(inputs: Legal_Reliability_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liability & Reliability`)
};

/**
* | output |
* | --- |
* | "Liability & Reliability" |
*
* @param {Legal_Reliability_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_reliability_title = /** @type {((inputs?: Legal_Reliability_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Reliability_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_legal_reliability_title(inputs)
	return en_legal_reliability_title(inputs)
});